import { RSAA } from 'redux-api-middleware';
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from '../../config/ApiConstants';


export function user_profile_Action(token, data) {
    return {
        [RSAA]: {
            endpoint: `${API_ENDPOINT}/me/profile`,
            method: 'POST',
            headers: {
                ...AUTH_HEADERS,
                'Authorization': `Bearer ${token}`,
            },
            body:JSON.stringify(data),
            types: [
                types.USER_PROFILE_REQUEST,
                types.USER_PROFILE_RECEIVE, {
                    type: types.USER_PROFILE_FAILURE,
                    meta: (action, state, res) => {
                        return (action, state, res);
                    }
                }]
        }
    }
}


export const reset_user_profile_Action = () => {
    return {
        type: types.RESET_USER_PROFILE,
        payload: null
    }
};
